import { reduce } from '@atlaskit/adf-utils/traverse';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { NotesByCreator_notesByCreator_nodes } from './__types__/GetNotesQuery.ts';

export type Note = Omit<NotesByCreator_notesByCreator_nodes, 'body' | 'extraProps'> & {
	adf: ADFEntity | undefined;
};

export type Notes = Note[];

export const extractAdfText = (adf: ADFEntity | undefined) => {
	/* Temporary way to get text from ADF in order to generate an excerpt before BE query is finished
	 * Also used for frontend filtering/search
	 * We want to get the text entries of any content nodes in the adf labelled with type: text
	 */
	if (adf) {
		return reduce(
			adf,
			(currentValue, node) => {
				if (node.type === 'text') {
					return `${currentValue} ${node.text}`.trim(); // trim to ensure we remove the space from template string if empty node.text
				} else {
					return currentValue;
				}
			},
			'',
		);
	}

	return '';
};

export const isNoteBlank = (note: Note | undefined) => {
	if (note) {
		const noteHasContent = note.adf && note.adf.content && note.adf.content.length > 0;
		return !noteHasContent && !note.title;
	}
	return true;
};
